import DataHelper from "./dataHelper";

const ApiDataHelper = {
    get: function (state, fields) {
        let apiData = {};
        Object.keys(fields).forEach(key => {
            if (fields[key] && (fields[key].type == "datetime" ||
                fields[key].type == "date") &&
                state[key] && state[key] instanceof Date) {
                if (fields[key].isStringDate) {
                    apiData[key] = DataHelper.getFormattedLocalISODate(state[key]);
                } else {
                    apiData[key] = DataHelper.getFormattedUTCDate(state[key]);
                }
            } else {
                apiData[key] = state[key];
            }
        });
        return apiData;
    },
    set: function (reducerAction, apiData, fields) {
        let stateData = [];
        Object.keys(fields).forEach(key => {
            if (fields[key] && typeof fields[key] === "object" &&
                fields[key].type === "password") {
                stateData.push({
                    key: key,
                    value: ""
                });
            } else {
                stateData.push({
                    key: key,
                    value: apiData && apiData[key] ? apiData[key] : ""
                });
            }
        });

        reducerAction(stateData);
    },
}

export default ApiDataHelper;